import { keys } from 'lodash-es'
import { OrderLineLookupContract, POSVariantGroup } from 'models'
import {
    convertToItemViewModel,
    ItemViewModel,
    UsedVariants,
} from 'store/models/sellModels'

export function buildUsedVariants(
    orderLine: OrderLineLookupContract,
    itemsMap: { [itemId: string]: ItemViewModel },
    variantGroupsMap: { [variantGroupId: string]: POSVariantGroup },
    isCombo: boolean = false,
    oldItemsMap: { [itemId: string]: ItemViewModel },
) {
    const usedVariants: UsedVariants = {}
    let itemId = orderLine.item?.baseItemID ?? orderLine.itemID!

    const existItem = itemsMap[itemId]
    let orderItem: ItemViewModel = {
        ...(existItem || convertToItemViewModel(orderLine.item!!)),
        itemId,
    }
    let isAvailable = true
    if (orderLine.item?.baseItem) {
        if (!existItem) {
            orderItem = convertToItemViewModel(orderLine.item.baseItem!!)
            oldItemsMap[orderLine.itemID!] = orderItem
        }

        orderLine.item?.baseItem?.itemVariantGroups?.forEach((group) => {
            group.variantGroup?.variantOptions?.forEach((option) => {
                if (
                    orderLine.item?.combinationIndices?.includes(
                        option.variantOptionID ?? '',
                    )
                )
                    usedVariants[option.variantGroupID!!] =
                        option.variantOptionID ?? ''
            })
        })
    }

    if (!existItem) {
        isAvailable = false
        oldItemsMap[orderLine.itemID!] = orderItem
    } else {
        isAvailable =
            existItem.variations.length > 0
                ? existItem.variations.some(
                      (s) =>
                          s.isAvailableForSelection &&
                          s.itemId === orderLine.itemID,
                  )
                : true
        if (!isCombo) {
            orderItem.price = orderLine.price ?? 0
        }
    }

    return {
        item: {
            ...orderItem,
            isAvailableForSelection: isAvailable,
        },
        usedVariants,
        oldVariantGroupMaps: restoreRemoveVariantOptionData(
            orderLine,
            usedVariants,
            variantGroupsMap,
        ),
    }
}
function restoreRemoveVariantOptionData(
    line: OrderLineLookupContract,
    usedVariants: UsedVariants,
    variantGroupsMap: { [variantGroupID: string]: POSVariantGroup },
) {
    const oldVariantGroup: { [variantGroupID: string]: POSVariantGroup } = {}
    keys(usedVariants).forEach((gId) => {
        const currentGroup = variantGroupsMap[gId]
        const group = line.item?.baseItem?.itemVariantGroups?.find(
            (v) => v.variantGroup?.variantGroupID === gId,
        )!
        let isChanged = false
        if (currentGroup) {
            let option = currentGroup.variantOptions?.find(
                (v) => v.variantOptionID === usedVariants[gId],
            )
            if (!option) {
                isChanged = true
            }
        } else {
            isChanged = true
        }
        if (isChanged) oldVariantGroup[gId] = group.variantGroup!
    })
    return oldVariantGroup
}
